import Reflux from "reflux";

import Chip from "@javascript/reactComponents/lds/chips/Chip";
import FacetSearchStore from "@javascript/stores/facetSearchStore";
import { FacetSearchLocationActions } from "@javascript/stores/actions/facetSearch/locationActions";

const FacetSearchCriteriaLocations = createReactClass({
  mixins: [
    Reflux.connectFilter(FacetSearchStore, function (data) {
      return {
        locations: data.location.selectedLocationCodes,
      };
    }),
  ],
  getInitialState() {
    return {
      locations: FacetSearchStore.data.location.selectedLocationCodes,
    };
  },
  render() {
    const { locations } = this.state;
    const locationsSelected = [];
    const lastIndex = locations.length - 1;

    for (let i = 0; i < locations.length; i++) {
      let isLast = lastIndex === i;
      if (locations[i] === "my_territory") {
        locationsSelected.push({
          name: "Your territory",
          value: locations[i],
          last: isLast,
        });
      } else {
        locationsSelected.push({
          name: Zymewire.loc_codes[locations[i]],
          value: locations[i],
          last: isLast,
        });
      }
    }

    // Lockery
    const original = Zymewire.original_feed_query;
    if (original && original.loc_codes && original.loc_codes.length > 0) {
      _.each(locationsSelected, function (locationSelected) {
        if (_.contains(original.loc_codes, locationSelected.value)) {
          locationSelected["locked"] = true;
        }
      });
      $("#loc_code_panel").hide();
    }

    if (locationsSelected.length > 0) {
      let locationsList = locationsSelected.map((location, index) => {
        return <LocationAppliedFilterEntry
          last={location.last}
          locked={location.locked}
          key={index}
          name={location.name}
          value={location.value}
        />;
      });

      return (
        <>
          {locationsList}
        </>
      );
    } else {
      return null;
    }
  },
});

const LocationAppliedFilterEntry = ({ last, locked, name, value}) => {

  let removeLocation = () => {
    FacetSearchLocationActions.removeLocation(value);
    return false;
  };

  const label = (
    <>
      {Zymewire.facet_search_filters.sponsor_company_location}: {name}
      {!last && <b> OR</b>}
    </>
  );

  return (
   <Chip
     className="search_filter_applied_chip"
     label={label}
     leadingIcon="map"
     size="small"
     {...!locked && {
       trailingIcon: "cancel",
       trailingIconClassName: "search_filter_applied_trailing_icon",
       trailingIconOnClick: removeLocation,
     }}
     title={`You are filtering your search by events specifically involving a company based in '${name}'. Click to remove this filter.`}
     variant="secondary"
   />
 );
}

window.FacetSearchCriteriaLocations = FacetSearchCriteriaLocations;
export default FacetSearchCriteriaLocations;

